import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { VcsService } from '../../../services/vcs.service';
import { BaseComponent } from '../../../../components/base/base.component';
import { VcsAPIService } from '../../../services/vcs-api/vcs-api.service';
import { NotificationService } from '@wms/services';
import { WmsDialogComponent } from '../../../../components/wms-dialog/wms-dialog.component';
import { WmsDialogHeaderComponent } from '../../../../components/wms-dialog-header/wms-dialog-header.component';
import { WmsDialogBodyComponent } from '../../../../components/wms-dialog-body/wms-dialog-body.component';
import { WmsDialogFooterComponent } from '../../../../components/wms-dialog-footer/wms-dialog-footer.component';
import { WmsMessageComponent } from '../../../../components/wms-message/wms-message.component';
import { WmsTypeaheadComponent } from '../../../../components/wms-typeahead/wms-typeahead.component';
import { WmsVcsPullDialogComponent } from '../wms-vcs-pull-dialog/wms-vcs-pull-dialog.component';

import { showMsg } from '@wms/app/vcs/utils/vcs-utils';
import { getValidJSON } from '@wm/core';

@Component({
  selector: 'wms-vcs-push-external-repo-dialog',
  templateUrl: './wms-vcs-push-external-repo-dialog.component.html',
  styleUrls: ['./wms-vcs-push-external-repo-dialog.component.less'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    WmsDialogComponent,
    WmsDialogHeaderComponent,
    WmsDialogBodyComponent,
    WmsDialogFooterComponent,
    WmsMessageComponent,
    WmsTypeaheadComponent,
    WmsVcsPullDialogComponent
  ],
})
export class WmsVcsPushExternalRepoDialogComponent extends BaseComponent {
  public vcsService: VcsService;
  private vcsAPIService: VcsAPIService;
  private notificationService: NotificationService;

  constructor() {
    super();
    this.vcsService = inject(VcsService);
    this.vcsAPIService = inject(VcsAPIService);
    this.notificationService = inject(NotificationService);
  }

  addToExternalVCS() {
    if (this.vcsService.validateVCSConfig(true)) {
      if (!this.vcsService.vcsBranchName) {
        this.vcsService.msgData = showMsg(
          this.locale.MESSAGE_WARN_BRANCH_EMPTY,
          'error'
        );
        return;
      }
      this.vcsService.isExportDisabled = true;
      this.vcsService.msgData = showMsg(
        this.locale.MESSAGE_VCS_ADDING,
        'loading'
      );
      let vcsConfig = {
        vcsDataSource: this.vcsService.vcsConfig,
        branch: this.vcsService.vcsBranchName,
      };
      this.vcsAPIService
        .addExternal(vcsConfig)
        .then((): void => {
          this.vcsService.closeDialogWithId('pushToExternalVCSModal');
          this.notificationService.show(
            'success',
            '',
            this.locale.MESSAGE_VCS_ADD_SUCCESS
          );
          this.cacheExternalRepoDetails();
        })
        .catch((error) => {
          this.vcsService.msgData = showMsg(
            error.error.errors.error[0].message.replace(
              '{0}',
              error.error.errors.error[0].parameters[0]
            ),
            'error'
          );
          this.vcsService.isExportDisabled = false;
        });
    }
  }

  cacheExternalRepoDetails() {
    let repoDetails =
      getValidJSON(
        localStorage.getItem(this.vcsService.EXTERNAL_REPO_DETAILS_KEY)
      ) || {};
      if (!repoDetails[this.vcsService.projectDetails.id]) {
        repoDetails[this.vcsService.projectDetails.id] = {};
    }
    repoDetails[this.vcsService.projectDetails.id][this.vcsService.vcsConfig.type]  = {
      username: this.vcsService.vcsConfig.username,
      url: this.vcsService.vcsConfig.url,
    };
    localStorage.setItem(
      this.vcsService.EXTERNAL_REPO_DETAILS_KEY,
      JSON.stringify(repoDetails)
    );
  }
}